import Events from "./Events";

export const MetaConsent = {
	REVOKED: 'revoke',
	GRANTED: 'grant'
};

class Meta {
	static PIXEL_ID = '823055930765491';
	static LOCAL_STORAGE_KEY = 'COOKS_DOORS_META_CONSENT';
	static IDLE_TIMER = 5000;
	static timeout;
	static initialized = false;
	static pixelLoaded = false;

	static setListeners() {
		document.addEventListener(Events.SCROLL, Meta.eventHandler);
		document.addEventListener(Events.MOUSE_MOVE, Meta.eventHandler);
		document.addEventListener(Events.TOUCH_START, Meta.eventHandler, { passive: true });

		Meta.timeout = setTimeout(() => {
			Meta.initPixel();
		}, Meta.IDLE_TIMER);
	}

	static eventHandler(e) {
		clearTimeout(Meta.timeout);
		Meta.initPixel();
		e.currentTarget.removeEventListener(e.type, Meta.eventHandler);
	}

	static initPixel() {
		if (Meta.initialized) return false;
		Meta.initialized = true;

		// Load the Meta Pixel script
		!function(f,b,e,v,n,t,s){
			if(f.fbq) return;
			n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
			if(!f._fbq) f._fbq=n;
			n.push=n; n.loaded=!0; n.version='2.0'; n.queue=[];
			t=b.createElement(e); t.async=!0; t.src=v;
			t.addEventListener(Events.LOAD, Meta.onPixelLoad);
			s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s);
		}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

		// Start with consent revoked
		window.fbq('consent', 'revoke');
		
		// Initialize the pixel
		window.fbq('init', Meta.PIXEL_ID);
	}

	static onPixelLoad() {
		Meta.pixelLoaded = true;
		
		// Check stored consent and apply it
		const storage = localStorage.getItem(Meta.LOCAL_STORAGE_KEY);
		const consentStatus = storage ? JSON.parse(storage) : null;
		
		if (consentStatus && consentStatus.meta_pixel === MetaConsent.GRANTED) {
			window.fbq('consent', 'grant');
		}
		
		// Track PageView after consent check
		window.fbq('track', 'PageView');
		
		// Set up click tracking for tel: and mailto: links
		Meta.setupContactTracking();
	}

	static setupContactTracking() {
		document.addEventListener(Events.CLICK, (e) => {
			const target = e.target.closest('a');
			if (!target) return;
			
			const href = target.getAttribute('href');
			if (!href) return;
			
			if (href.startsWith('tel:') || href.startsWith('mailto:')) {
				Meta.trackContact();
			}
		});
	}

	static trackContact() {
		if (!Meta.initialized || typeof window.fbq !== 'function') return;
		window.fbq('track', 'Contact');
	}

	static trackLead() {
		if (!Meta.initialized || typeof window.fbq !== 'function') return;
		window.fbq('track', 'Lead');
	}

	static grantConsent() {
		if (!Meta.initialized) {
			Meta.initPixel();
		}
		
		if (typeof window.fbq === 'function') {
			window.fbq('consent', 'grant');
		}

		localStorage.setItem(
			Meta.LOCAL_STORAGE_KEY,
			JSON.stringify({
				meta_pixel: MetaConsent.GRANTED
			})
		);
	}

	static revokeConsent() {
		if (!Meta.initialized) return;
		
		if (typeof window.fbq === 'function') {
			window.fbq('consent', 'revoke');
		}

		localStorage.setItem(
			Meta.LOCAL_STORAGE_KEY,
			JSON.stringify({
				meta_pixel: MetaConsent.REVOKED
			})
		);
	}

	static resetConsent() {
		localStorage.removeItem(Meta.LOCAL_STORAGE_KEY);
	}
}

export default Meta;
